import { render, staticRenderFns } from "./BaseTemp.vue?vue&type=template&id=60a2bb7a"
import script from "./BaseTemp.vue?vue&type=script&lang=js"
export * from "./BaseTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports